import { useQueryClient } from "@tanstack/react-query";
import { applicationApi } from "api/application";
import { InputSize } from "shared/components";
import { AssigneeSelect as SharedAssigneeSelect } from "shared/components/Assignee";

interface AssigneeSelectProps {
  value?: number | null;
  rowId?: string;
  // Restricts the options to users with access to this property so that
  // applications are not assigned to users who cannot view them.
  propertyId?: number;
  // Restricts the options to users with access to ALL these properties, for
  // bulk assignment across applications that may span multiple properties.
  propertyIds?: number[];
  inputClassName?: string;
  onChange?: (partner_user_id: number | null) => void;
  label?: string;
  size?: InputSize;
  compact?: boolean;
}

export const AssigneeSelect = ({
  value,
  rowId,
  propertyId,
  propertyIds,
  inputClassName,
  onChange,
  label,
  size,
  compact
}: AssigneeSelectProps) => {
  const queryClient = useQueryClient();

  const handleAssign = async (
    row_id: string,
    partner_user_id: number | null
  ) => {
    return applicationApi.assignApplication({
      application_id: Number(row_id),
      assignee_ids: partner_user_id !== null ? [partner_user_id] : []
    });
  };

  const handleAssignSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ["APPLICATION_ACTIVITY_LOG"] });
    queryClient.invalidateQueries({ queryKey: ["APPLICANTS_TABLE"] });
    if (rowId)
      queryClient.invalidateQueries({ queryKey: ["APPLICATION", rowId] });
  };

  return (
    <SharedAssigneeSelect
      value={value}
      rowId={rowId}
      propertyId={propertyId}
      propertyIds={propertyIds}
      inputClassName={inputClassName}
      onChange={onChange}
      onAssign={handleAssign}
      onAssignSuccess={handleAssignSuccess}
      label={label}
      size={size}
      compact={compact}
      successMessage="Application assigned successfully"
      errorMessage="Failed to assign application"
    />
  );
};
